import {lazy} from "../../lib/lazy.js";
export const logisticsManagementRoutes = [
  {
    path: "/logistics-management/inquire-freight",
    component: lazy(() => import(/* webpackChunkName: "logisticsManagementRoutes" */ "../../views/logistics-management/InquireFreight.js"))
  }
];
